module.exports = __webpack_public_path__ + "img/BELG.21597e7b.png";